module.exports = "/static/assets/9dfaec413ea561cda64edfcd9aef8523.png";